import _ from 'lodash';
import React from 'react';
import { Field } from '../../../types/FieldCommon';
import { UserSettingsCollapseKeys } from '../../../types/User';
import AccordionSection from '../../AccordionSection';
import { Box } from '@mui/material';
import FieldInput from './FieldInput';

interface IFieldSectionProps {
  fields: Field[];
  setFields: (fields: Field[]) => void;
  collapseId: UserSettingsCollapseKeys;
  title?: string;
}

export default function FieldsSection({ fields, setFields, collapseId, title = 'More Details' }: IFieldSectionProps) {
  const updateFieldValue = (uuid: string, value: any) => {
    const field: Field | undefined = _.find(fields, { uuid });
    if (!field) return;
    const newField: Field = {
      ...field,
      value,
    };
    setFields(_.map(fields, (f) => (f.uuid === uuid ? newField : f)));
  };

  return (
    <AccordionSection title={title} collapseId={collapseId} hasData={fields.length > 0}>
      <Box style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
        {_.map(fields, (field) => (
          <Box my={1} key={field.uuid}>
            <FieldInput field={field} updateFieldValue={(value) => updateFieldValue(field.uuid, value)} />
          </Box>
        ))}
      </Box>
    </AccordionSection>
  );
}
